<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  import MetaMaskOnboarding from '@metamask/onboarding';

  import * as contracts from './lib/contracts';


  const dispatch = createEventDispatcher();

  const onboarding = new MetaMaskOnboarding();

  let accounts = [];
  let isConnected = false

  async function handleNewAccounts(newAccounts) {
    accounts = newAccounts;
    isConnected = await contracts.isConnected();
  }

  const isMetamaskInstalled = MetaMaskOnboarding.isMetaMaskInstalled;

  // onMount(async () => {
  //   console.log(1)
  //   if (isMetamaskInstalled()) {
  //     window.ethereum
  //       .request({ method: 'eth_requestAccounts' })
  //       .then(handleNewAccounts);
  //     window.ethereum.on('accountsChanged', handleNewAccounts);
  //   }
  // });

  // onDestroy(() => window.ethereum.removeListener('accountsChanged', handleNewAccounts));

  function startOnboarding() {
    if (!isMetamaskInstalled())
      onboarding.startOnboarding();
  }

  function connect() {
    if (isMetamaskInstalled()) {
      window.ethereum
              .request({ method: 'eth_requestAccounts' })
              .then(handleNewAccounts);
    }
  }

  async function switchNetwork() {
    try {
      const switched = await contracts.switchNetwork();
      isConnected = switched;
      if (!switched) {
        alert("Error switching to Polygon");
      } else {
        dispatch('switch')
      }
    } catch (err) {
      alert("Error switching to Polygon");
    }

  }

  connect()
</script>


<div class="grid grid-rows-1 w-80 m-auto gap-y-6 py-10">
  <button on:click={startOnboarding} type="button"
          class="inline-flex items-center px-6 py-3 border border-transparent shadow-sm text-base font-medium rounded-md text-indigo-700 focus:outline-none"
          class:hover:bg-indigo-200={!isMetamaskInstalled()}
          class:cursor-pointer={!isMetamaskInstalled()}
          class:cursor-default={isMetamaskInstalled()}
          class:bg-white={true}
          class:bg-green-50_={isMetamaskInstalled()}>
    <!-- Heroicon name: solid/mail -->
    <!-- <span class="px-6 py-4 flex items-center text-sm font-medium"> -->
    {#if isMetamaskInstalled()}
      <span class="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-green-400 rounded-full">
        <!-- Heroicon name: solid/check -->
        <svg class="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
          <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
        </svg>
      </span>
    {:else}
      <span class="w-10 h-10 flex items-center justify-center border-2 border-blue-500 rounded-full">
        <span class="text-blue-700">1</span>
      </span>
    {/if}
    <!-- <span class="ml-4 text-sm font-medium text-gray-900">Job details</span> -->
    <!-- </span> -->
    {#if !isMetamaskInstalled()}
      <span class="ml-4 text-blue-700">Install MetaMask</span>
    {:else}
      <span class="ml-4 text-green-600">Metamask Installed</span>
    {/if}
  </button>

  <button on:click={connect} type="button"
          class="inline-flex items-center px-6 py-3 border border-transparent shadow-sm text-base font-medium rounded-md text-indigo-700 bg-white focus:outline-none"
          class:hover:bg-indigo-200={!accounts.length}
          class:cursor-pointer={!accounts.length}
          class:cursor-default={accounts.length}
          class:bg-white={true}
          class:bg-green-50_={accounts.length}>
    <!-- Heroicon name: solid/mail -->
    <!-- <span class="px-6 py-4 flex items-center text-sm font-medium"> -->
    {#if isMetamaskInstalled()}
      {#if accounts.length}
        <span class="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-green-400 rounded-full">
          <!-- Heroicon name: solid/check -->
          <svg class="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        </span>
      {:else}
        <span class="w-10 h-10 flex items-center justify-center border-2 border-blue-500 rounded-full">
          <span class="text-blue-700">2</span>
        </span>
      {/if}
    {:else}
      <span class="w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full">
        <span class="text-gray-500">2</span>
      </span>
    {/if}
    <!-- <span class="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-indigo-600 rounded-full">
      <!- - Heroicon name: solid/check - ->
      <svg class="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
      </svg>
    </span> -->
    <!-- <span class="ml-4 text-sm font-medium text-gray-900">Job details</span> -->
    <!-- </span> -->
    {#if accounts.length <= 0}
      <span class="ml-4"
            class:text-blue-700={isMetamaskInstalled()}
            class:text-gray-400={!isMetamaskInstalled()}>Connect with MetaMask</span>
    {:else}
      <span class="ml-4 text-green-600">Metamask connected</span>
    {/if}
    <!-- <span class="ml-4"
          class:text-blue-700={isMetamaskInstalled()}
          class:text-gray-400={!isMetamaskInstalled()}>Connect with MetaMask</span> -->
  </button>




  <button on:click={switchNetwork} type="button"
          class="inline-flex items-center px-6 py-3 border border-transparent shadow-sm text-base font-medium rounded-md text-indigo-700 bg-white focus:outline-none"
          class:hover:bg-indigo-200={accounts.length}
          class:cursor-pointer={accounts.length}
          class:cursor-default={!isConnected}
          class:bg-white={true}
          class:bg-green-50_={isConnected}>
    <!-- Heroicon name: solid/mail -->
    <!-- <span class="px-6 py-4 flex items-center text-sm font-medium"> -->
    {#if accounts.length}
      {#if isConnected}
        <span class="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-green-400 rounded-full">
          <!-- Heroicon name: solid/check -->
          <svg class="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
          </svg>
        </span>
      {:else}
        <span class="w-10 h-10 flex items-center justify-center border-2 border-blue-500 rounded-full">
          <span class="text-blue-700">3</span>
        </span>
      {/if}
    {:else}
      <span class="w-10 h-10 flex items-center justify-center border-2 border-gray-300 rounded-full">
        <span class="text-gray-500">3</span>
      </span>
    {/if}
    <!-- <span class="flex-shrink-0 w-10 h-10 flex items-center justify-center bg-indigo-600 rounded-full">
      <!- - Heroicon name: solid/check - ->
      <svg class="w-6 h-6 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
        <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
      </svg>
    </span> -->
    <!-- <span class="ml-4 text-sm font-medium text-gray-900">Job details</span> -->
    <!-- </span> -->
    {#if !isConnected}
      <span class="ml-4"
            class:text-blue-700={accounts.length}
            class:text-gray-400={!accounts.length}>Switch to Polygon</span>
    {:else}
      <span class="ml-4 text-green-600">Switched to Polygon</span>
    {/if}
    <!-- <span class="ml-4"
          class:text-blue-700={isMetamaskInstalled()}
          class:text-gray-400={!isMetamaskInstalled()}>Connect with MetaMask</span> -->
  </button>
</div>


<!-- <svg class="-ml-1 mr-3 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
</svg> -->

<!-- <button disabled={isDisabled} on:click={onClick}>
  {buttonText}
</button> -->
